import { Table, Tag } from 'antd'
import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { virtueleAfsluitingen, ttrQuery } from './queries'
import { copyToClipboard, evaluateMoment, HideClosed, sorter } from './helpers'

const dutchNames = {
  'code': 'bk',
  'status': 'status',
  'reden': 'reden',
  'start': 'start',
  'eind': 'eind',
  'fullCode': 'locatie'
}

const columns = ['code', 'status', 'reden', 'start', 'eind', 'fullCode']
  .map((key) => ({
      title: _.startCase(dutchNames[key]),
      dataIndex: key,
      key,
      sorter: (a, b) => sorter(a[key], b[key])
    }))
  columns[0].render = (item) => {
    return <span key={`item-bk-${item.value}`}>
      <Tag color={item.left > 0 ? 'orange' : 'red'}><b>{item.value}</b> {item.hours} / {item.ttr} TTR</Tag><br/>
    </span>
  }
  columns[5].render = (list) => {
    return <>
      {list.map((item, i) => {
        return <span key={`item-location-${i}`}>{item}<br/></span>
      })}
    </>;
  }

const reduceVirtueleAfsluitingenData = (rows, ttrMap) => {
  const buildBkTiles = (resultCell, duur) => {
    const bk = resultCell.value;
    const hours = Math.ceil(duur / 1000 / 60 / 60);
    const ttr = Number(ttrMap[bk]);
    const left = Math.max(0, Math.ceil(ttr - hours));
    return { value: bk, hours, left, ttr };
  }
  const buildLocationTiles = (resultCell) => {
    return resultCell.children.fullCode.reduce((acc, item) => {
      acc.push(item.value);
      return acc;
    }, []);
  }
  return rows.map((row, i) => ({
    key: i,
    now: evaluateMoment(row.now[0]),
    code: buildBkTiles(row.code[0], row.duur[0].value),
    status: `${row.status[0]?.value}` || "",
    reden: `${row.code[0]?.value} - ${row.melding[0]?.value}` || "",
    start: evaluateMoment(row.start[0]),
    eind: evaluateMoment(row.eind[0]),
    fullCode: buildLocationTiles(row.code[0])
  }))
}

const reduceTtrData = (nodeSets) => {
  const res = {};
  nodeSets.bk.forEach((bk, i) => {
    res[bk.value] = nodeSets.ttr[i]?.value || "";
  });
  return res;
}

const VirtueleAfsluitingen = ({ ...props }) => {

  const [hideClosed, setHideClosed] = useState(true)
  const { spaceId } = useParams();

  const ttrData = useQuery(
    [`${spaceId}.virtueleAfsluitingen.dashboard.ttr`],
    () => new Weaver.Sparql(ttrQuery()).find()
  )

  const { data, isLoading, error } = useQuery({
    queryKey: [`${spaceId}.virtueleAfsluitingen.dashboard`],
    queryFn: async () => {
      const res = await new Weaver.Sparql(virtueleAfsluitingen(), undefined, 'afsluitingen').iterator(
        {'fullCode': 'code'},
        'code',
        ((n)=> n?.id()),
        ((a)=> a?.value),
      ).all();
      return reduceVirtueleAfsluitingenData(res, reduceTtrData(ttrData.data))
    },
    enabled: !!ttrData.data,
  })


  const title = (_data) => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        { copyToClipboard(_data)() }
        <HideClosed setHideClosed={setHideClosed}/>
      </div>
    )
  }

  const filterHidden = (_data) => {
    return _data.filter((item) => item.eind === item.now)
  }

  return (
    <Table
      title={data ? () => title(data) : () => null}
      pagination={{position: ["topRight", "none"]}}
      loading={isLoading && ttrData.isLoading}
      bordered={true}
      columns={columns}
      dataSource={hideClosed ? filterHidden(data || []) : data}
      {...props}
    />
  )
}

VirtueleAfsluitingen.title = "Virtuele afsluitingen"

export default VirtueleAfsluitingen

